<template>
  <div>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      /
      <router-link :to="{ name: 'admin-import' }" class="root">
        Admin Import
      </router-link>
      <span class="child">/ Import Program </span>
    </v-row>
    <br />
    <v-card class="card">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card-title class="heading">Import Program</v-card-title>
      <v-card class="box">
        <div class="flex">
          <div></div>
          <div>
            <a
              href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/program.csv"
            >
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="success"
                class="ma-2 white--text downbtn"
                @click="loader = 'loading3'"
              >
                <v-icon left dark>mdi-cloud-download</v-icon>Download import CSV
                format
              </v-btn>
            </a>
          </div>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12" lg="4" sm="12">
              <v-file-input
                dense
                v-model="file"
                :hint="file != null ? '' : 'Please Select File'"
                persistent-hint
                color="rgb(1, 127, 152)"
                label="Choose File"
                accept=".csv"
                prepend-icon="mdi-paperclip"
                outlined
                show-size
              >
              </v-file-input>
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" align="center">
              <v-btn @click="submitFile" :loading="output_load" class="button">
                Upload
                <v-icon right>mdi-cloud-upload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <template v-if="load == true">
        <v-data-table
          :headers="headers"
          sort-by
          class="elevation-1"
          :search="search"
          :loading="output_load"
           v-model="selected"
            @current-items="getFiltered"
                :items="programList1" 
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <download-excel
                class="mar"
                :data="filterArr"
                :fields="export_table_headers"
                worksheet="programList"
                name="ProgramData.xls"
              >
                <v-btn color="success" dark class="mb-2">
                  Export<v-icon dark>mdi-file-excel</v-icon>
                </v-btn>
              </download-excel>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <span style="width: 20px;"></span>
              <v-btn class="button" @click="openDialog">
                <v-icon left>mdi-account-plus</v-icon>Add New Program
              </v-btn>
            </v-toolbar>
             <tr class="t-row">
                        <div>
                            <th class="d-flex">
                                <span v-for="header in headers" :key="header.text">
                                   <span v-if="filters.hasOwnProperty(header.value)">
                                    <v-autocomplete class="mr-5" flat hide-details small dense outlined :label="header.text" multiple clearable :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
                                   </span>
                                   
                                </span>
                              
                            </th>
                        </div>
                    </tr>
          </template>
          <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive == true">
              <v-icon class="mr-2" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
          <template v-slot:item.edit="{ item }">
            <div>
              <v-avatar size="33" class="edit-avatar">
                <v-icon
                  color="rgb(1, 127, 152)"
                  size="18"
                  @click="editDialogFunction(item)"
                  >mdi-pencil</v-icon
                >
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </template>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="heading">
            <span>Add New Program</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="defaultItem.program_name"
                    label="Name"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="defaultItem.program_display_name"
                    label="Display name"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    :items="programTypeList"
                    v-model="defaultItem.program_type_name"
                    label="Program Type"
                    :hint="
                      defaultItem.program_type_name != null
                        ? ''
                        : 'Please Select Program Type'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    :items="departmentList"
                    v-model="defaultItem.department_name"
                    label="Department"
                    :hint="
                      defaultItem.department_name != null
                        ? ''
                        : 'Please Select Department'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="defaultItem.isactive"
                    label="Is-active"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button-cancel" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn class="button" text @click="saveProgram">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editDialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="heading">
            <span>Edit Program Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.program_name"
                    label="Program Name"
                    :hint="
                      editedItem.program_name != null
                        ? ''
                        : 'Please enter Program Name'
                    "
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.program_display_name"
                    label="Display Name"
                    :hint="
                      editedItem.program_display_name != null
                        ? ''
                        : 'Please enter Program Name'
                    "
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.program_type_name"
                    label="Program type"
                    :items="programTypeList"
                    required
                    :hint="
                      editedItem.program_type_name != null
                        ? ''
                        : 'Please Select Program Type'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="editedItem.department_name"
                    label="Department"
                    :items="departmentList"
                    required
                    :hint="
                      editedItem.department_name != null
                        ? ''
                        : 'Please Select Department'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    dense
                    v-model="editedItem.isactive"
                    color="success"
                    label="Active?"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button-cancel" text @click="editDialog = false"
              >Close</v-btn
            >
            <v-btn class="button" text @click="saveEdited">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <!-- not import -->
    <v-row justify="center">
      <v-dialog
        v-model="dialog_faildata"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar class="heading">
            <v-btn icon dark @click="dialog_faildata = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title style="color:#FFF;"
              >Program Not Import</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <download-excel
                style="margin-top:10px;"
                :data="failList"
                :fields="table_"
                worksheet="Program_Not_Import"
                name="Program_Not_Import.xls"
              >
                <v-btn class="ma-1 white--text" color="green">
                  <v-icon dark>
                    mdi-file-excel-box
                  </v-icon>
                  Export to Excel
                </v-btn>
              </download-excel>
              <v-btn dark text @click="dialog_faildata = false">
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-simple-table fixed-header height="800px">
            <template>
              <thead>
                <tr color="red">
                  <th class="text-left">Sr.No</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">Display Name</th>
                  <th class="text-left">Program Type</th>
                  <th class="text-left">Department</th>
                  <th class="text-left">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in failList" :key="item">
                  <td style="color:red;">{{ item.srno }}</td>
                  <td style="color:red;">{{ item.name }}</td>
                  <td style="color:red;">{{ item.dname }}</td>
                  <td style="color:red;">{{ item.pt }}</td>
                  <td style="color:red;">{{ item.dept }}</td>
                  <td style="color:red;">
                    {{ item.reason }} - Data is missing
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      table_: {
        Name: "name",
        Display_name: "dname",
        Progarm_Type: "pt",
        Department: "dept",
        Remark: "reason",
      },
      dialog_faildata: false,
      failList: [],
      file: null,
      load: false,
      loading3: false,
      search: "",
      dialog: false,
      editDialog: false,
      programList: null,
      programTypeList: null,
      departmentList: null,
      program_id: "",
      program_name: "",
      program_display_name: "",
      program_type_name: "",
      department_name: "",
      isactive: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      export_table_headers: {
        "Sr.No.": "srno",
        Name: "program_name",
        "Display Name": "program_display_name",
        "Program Type": "program_type_name",
        Department: "department_name",
        Isactive: "isactive",
      },
      headers: [
        { text: "Sr.no", value: "srno" },
        { text: "Name", value: "program_name" },
        { text: "Display Name", value: "program_display_name" },
        { text: "Program Type", value: "program_type_name" },
        { text: "Department", value: "department_name" },
        { text: "Is-active", value: "isactive" },
        { text: "Action", value: "edit" },
      ],
       filters: {
                program_name: [],
                program_display_name: [],
                department_name: [],
                
               
            },
        selected: [],
        filterArr: [],
      defaultItem: {
        program_id: "",
        program_name: "",
        program_display_name: "",
        program_type_name: "",
        department_name: "",
        isactive: true,
      },
      editedItem: {
        program_id: "",
        program_name: "",
        program_display_name: "",
        program_type_name: "",
        department_name: "",
        isactive: false,
      },
      output_load: false,
    };
  },
  computed: {
  
     programList1() {
               return this.programList.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
        getFiltered(e) {
                    console.log(e);
                    this.filterArr = e;
                },
        columnValueList(val) {
            return this.programList.map((d) => d[val]);
        },
    submitFile() {
      if (this.file == null) {
        this.showSnackbar("#b71c1c", "Please select the CSV file!"); // show snackbar
      } else {
        this.output_load = true;
        let formData = new FormData();
        formData.append("file", this.file);
        axios
          .post("AdminImport/importAdminProgram", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.msg == "200") {
              this.failList = res.data.failsRecord;
              this.dialog_faildata = true;
              this.showSnackbar(
                "#4caf50",
                "Partially Programs added successfully..."
              );
              this.onLoad();
            }
          })
          .catch(function() {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction
    saveProgram() {
      this.dialog = false;
      axios
        .post("/AdminImport/saveProgram", this.defaultItem)
        .then((res) => {
          if (res.data.status == "Yes") {
            this.showSnackbar("#4caf50", "Program added successfully..."); // show snackbar on success
            this.onLoad();
          } else if (res.data.status == "NO") {
            this.showSnackbar("#4caf50", "Program Already Present..."); // show snackbar on success
            // this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    openDialog() {
      this.dialog = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editDialogFunction(val) {
      this.editedItem = Object.assign({}, val);
      this.editDialog = true;
    },
    onLoad() {
      axios
        .post("/AdminImport/importProgramHome")
        .then((res) => {
          if (res.data.msg == "200") {
            this.programList = res.data.program_list;
            this.programTypeList = res.data.programtype_list;
            this.departmentList = res.data.department_list;
            this.load = true;
            this.org = res.data.org;
          } else {
            this.programList = null;
            this.programTypeList = null;
            this.departmentList = null;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    saveEdited() {
      axios
        .post("/AdminImport/editProgram", this.editedItem)
        .then((res) => {
          if (res.data.status == "Yes") {
            this.showSnackbar("#4caf50", "Program Updated successfully..."); // show snackbar on success
            this.editDialog = false;
            this.onLoad();
          } else if (res.data.status == "No") {
            this.showSnackbar("#4caf50", "Program Already Present..."); // show snackbar on success

            this.onLoad();
          } else {
            this.editDialog = false;
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          window.console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.downbtn {
  float: right;
}
.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 600px) {
  .flex {
    display: block;
  }
}
.btn {
  margin: 1rem;
  padding-top: 1rem;
}
</style>
